<div class="page-title-area">
    <img src="assets/images/superiorstory.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2> The Superior story</h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">About</li>
            </ul> -->
        </div>
    </div>

        <!-- <div class="page-shape">
            <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
            <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
            <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
            <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
            <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
        </div> -->
</div>

<section class="home-company-area">
    <div class="container">
        <div class="row align-items-flex-start">
            <div class="col-lg-4 col-md-12">
                <div class="company-content">
                    <div class="company-tittle">
                        <h2>Superior story</h2>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-md-12">
                <div class="company-content">
                    <div class="company-tittle">
                        <p>Superior began its journey in 2013 with just three dedicated core members committed to excellence and innovation. Over the years, their relentless efforts and visionary leadership have expanded the team to over 100 talented professionals. Today, Superior proudly serves more than 900 enterprise customers, ensuring top-notch services and solutions tailored to their needs.</p>
                        <p>With strategic partnerships established with over 30 premium brands, Superior continues to strengthen its industry presence. Their success is echoed in the smiles of over 1,000 happy customers who have trusted and remained loyal to the brand over the years.</p>
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="row align-items-center" style="display: flex0; align-items: center; margin: 20px; justify-content: center;">
            <div class="col-lg-6 col-md-12">
                <div class="company-img">
                    <img src="assets/images/company/company-img.jpg" alt="company" />
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="services-details-area ptb-100">
    <div class="container">
        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h4>Superior story</h4>
                </div>

                <div class="col-lg-6">
                    <p>Superior began its journey in 2013 with just three dedicated core members committed to excellence and innovation. Over the years, their relentless efforts and visionary leadership have expanded the team to over 100 talented professionals. Today, Superior proudly serves more than 900 enterprise customers, ensuring top-notch services and solutions tailored to their needs. With strategic partnerships established with over 30 premium brands, Superior continues to strengthen its industry presence. Their success is echoed in the smiles of over 1,000 happy customers who have trusted and remained loyal to the brand over the years.</p>
                </div>
            </div>
        </div>
        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="company-img">
                        <img src="assets/images/company/company-img.jpg" alt="company" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="home2-choose-area pt-100 pb-70 bg-color">
    <div class="container">
        <div class="row" style="align-items: center;">
            <div class="col-lg-3 col-sm-4" >

        <div class="section-title" style="align-items: center;" >
            <!-- <span>Choose Aiva</span> -->
            <h2 style="font-size: 150px; font-weight: 600; color: var(--greyColor);">13</h2>
            <p style="font-size: 20px;">Years of Excellence</p>
            <p style="font-size: 20px;">"Crafting Reliable IT Solutions"</p>
        </div>
        </div>

            <!-- <div class="col-lg-2 col-sm-4">
                <div class="single-choose">
                    <div class="icon">
                        <p>9+</p>
                    </div>
                    <h3>Years of Experience</h3>
                </div>
            </div> -->

            <div class="col-lg-3 col-sm-4">
                <div class="single-choose story">
                    <div class="icon">
                        <p class="counter" style="color: #ce202f;">{{ serviceLocations }}</p>
                    </div>
                    <h3>30 Service Locations</h3>
                </div>
            </div>

            <div class="col-lg-3 col-sm-4">
                <div class="single-choose story">
                    <div class="icon">
                        <p class="counter" style="color: #ce202f;">{{ happyCustomers }}+</p>
                    </div>
                    <h3>Happy Customers</h3>
                </div>
            </div>

            <div class="col-lg-3 col-sm-4">
                <div class="single-choose story">
                    <div class="icon">
                        <p class="counter" style="color: #ce202f;">{{ salesSupport }}+</p>
                    </div>
                    <h3>Sales & Support Team</h3>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="technology-area ptb-100 bg-color">
    <div class="container">
        <div class="row align-items-center choose-c">
            <div class="col-lg-6">
                <div class="choose-img">
                    <img src="assets/images/choose-img1.jpg" alt="choose" />

                    <div class="technology-video">
                        <button type="button" class="video-btn p-0 border-0" (click)="openPopup()">
                            <i class='bx bx-play' ></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="technology-content">
                    <h2>Updated Technology</h2>
                    <p>You need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going There are many variations of passages of Lorem Ipsum available, but the.</p>
                    <a routerLink="/contact" class="box-btn">Contact Us</a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Video Popup -->
<!-- <div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe src="https://www.youtube.com/embed/XNQk1qt__Vw" title="Setup and Local Installation - React Nextjs Online Yoga Coaching &amp; Training Courses System" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bx bx-x'></i>
        </button>
    </div>
</div> -->

<!-- <section class="feature-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="contnet">
                    <div class="feature-tittle">
                        <span>Features</span>
                        <h2>We Have Also Some Features That Provided by Aiva</h2>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt consectetur, beatae quod eaque reprehenderit non ab quibusdam doloribus voluptatibus! Voluptatum aspernatur quasi id dolore doloremque quo vero</p>
                    </div>
                    <ul>
                        <li><i class="flaticon-correct"></i> Freelancing Traning Course</li>
                        <li><i class="flaticon-correct"></i> Technological Consultation</li>
                        <li><i class="flaticon-correct"></i> Monthly Paid Workspace</li>
                        <li><i class="flaticon-correct"></i> IT Learning Institute</li>
                        <li><i class="flaticon-correct"></i> Digital Marketing</li>
                    </ul>
                    <a routerLink="/contact" class="box-btn">Lets Talk!</a>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="feature-img">
                    <img src="assets/images/feature-img.png" alt="feature" />
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="client-area ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <span>Testimonials</span>
            <h2>What Our Client’s Say</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. A facilis vel consequatur tempora atque blanditiis exercitationem incidunt, alias corporis quam assumenda dicta.</p>
        </div>
        <div class="client-wrap">
            <owl-carousel-o [options]="clientWrap">
                <ng-template carouselSlide>
                    <div class="single-client">
                        <img src="assets/images/client/1.jpg" alt="img">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem Ipsum is simply dummy text of the printing Quis suspendisse typesetting ipsum dolor sit amet,</p>
                        <h3>Steven Jony</h3>
                        <span>CEO of Company</span>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-client">
                        <img src="assets/images/client/2.jpg" alt="img">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem Ipsum is simply dummy text of the printing Quis suspendisse typesetting ipsum dolor sit amet,</p>
                        <h3>Omit Jacson</h3>
                        <span>Company Founder</span>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</section> -->